/** Normalizza branche da API/snapStore per le pagine pubbliche. */
export function mapBrancheList(data) {
  if (!Array.isArray(data)) return [];
  return data.map((b) => ({
    id: b.id,
    branca: (b.branca || '').replace(/^./, (c) => c.toUpperCase()),
    intro: b.intro || '',
  }));
}

/** Griglia home: ordine stabile (no Math.random) per hydration e SEO. */
export function pickHomeDisciplineList(data, limit = 12) {
  return mapBrancheList(data)
    .sort((a, b) => a.branca.localeCompare(b.branca, 'it'))
    .slice(0, limit);
}
